module.exports = __webpack_public_path__ + "img/1508186490.ebd4caf7.jpg";